import styled from 'styled-components';
import { theme, toRem } from 'design';

interface IWrapperProps {
  gap?: number;
  direction?: 'row' | 'column';
  noWrap?: boolean;
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  size?: 'fill' | 'fit-content';
  width?: string | number; // Custom width override
  height?: string | number; // Custom height override
  flexGrow?: number; // Flex grow property - how much the item should grow relative to other items
  flexShrink?: number; // Flex shrink property - how much the item should shrink relative to other items
  flexBasis?: string | number; // Flex basis property - initial size before free space is distributed
  flex?: string; // Flex shorthand (overrides individual flex properties)
  padding?: string; // Custom padding override
}

export const Wrapper = styled.div<IWrapperProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'row'};
  align-items: ${({ alignItems }) => alignItems ?? 'flex-start'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'flex-start'};
  gap: ${({ gap }) => toRem(gap ?? theme.space.sm)};
  flex-wrap: ${({ noWrap }) => (noWrap ? 'nowrap' : 'wrap')};
  padding: ${({ padding }) => padding ?? 0};
  width: ${({ width }) => (typeof width === 'number' ? toRem(width) : width || 'auto')};
  height: ${({ height }) => (typeof height === 'number' ? toRem(height) : height || 'auto')};

  /* Flex properties */
  ${({ flex, flexGrow, flexShrink, flexBasis }) => `flex: ${flex || `${flexGrow ?? 1} ${flexShrink ?? 1} ${typeof flexBasis === 'number' ? toRem(flexBasis) : flexBasis || 'auto'}`};`}
`;
